'use client';

import React from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { AlertTriangle } from 'lucide-react';

interface ComponentErrorBoundaryProps {
  children: React.ReactNode;
  componentName?: string;
  fallback?: React.ReactNode;
}

export function ComponentErrorBoundary({ children, componentName, fallback }: ComponentErrorBoundaryProps) {
  const defaultFallback = (
    <div className="flex items-center gap-2 p-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg">
      <AlertTriangle className="h-4 w-4 flex-shrink-0" />
      <span>{componentName ? `Error loading ${componentName}` : 'Component error'}</span>
    </div>
  );

  return <ErrorBoundary fallback={fallback || defaultFallback}>{children}</ErrorBoundary>;
}
